import type { AdminJwtClaims } from '../api/types';

/** Decode a JWT payload without verifying (verification is the server's job). */
export function decodeJwt(token: string): AdminJwtClaims | null {
  try {
    const payload = token.split('.')[1];
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(escape(json))) as AdminJwtClaims;
  } catch {
    return null;
  }
}

export function isExpired(claims: AdminJwtClaims | null, skewSeconds = 0): boolean {
  if (!claims?.exp) return true;
  return Date.now() / 1000 >= claims.exp - skewSeconds;
}

/** Milliseconds until the token expires (clamped at 0). */
export function msUntilExpiry(claims: AdminJwtClaims | null): number {
  if (!claims?.exp) return 0;
  return Math.max(0, claims.exp * 1000 - Date.now());
}
